/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_PublishedInputs */

const cs_blog_published = /** @type {(inputs: Blog_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Článek publikován`)
};

const en_blog_published = /** @type {(inputs: Blog_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article published`)
};

/**
* | output |
* | --- |
* | "Article published" |
*
* @param {Blog_PublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_published = /** @type {((inputs?: Blog_PublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_PublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_published(inputs)
	return cs_blog_published(inputs)
});